// Static content data for SN Associates marketing site
// Backend endpoints (Phase 2):
// - POST /api/consultations -> Book consultation
// - POST /api/contact -> Contact form submission

export const servicesData = [
  {
    id: 'accounting',
    title: 'Accounting Services',
    description: 'Bookkeeping, payroll, financial statements, ledger maintenance, and monthly reporting.',
    icon: 'Calculator',
    features: ['General Ledger Maintenance', 'Accounts Payable/Receivable', 'Payroll Processing', 'Monthly Financial Reports']
  },
  {
    id: 'tax',
    title: 'Tax Consultation',
    description: 'Income tax planning, return filing, tax compliance, and tax-saving strategies.',
    icon: 'FileText',
    features: ['Corporate & Individual Tax', 'Tax Planning & Advisory', 'IRS/Tax Audit Representation', 'International Taxation', 'Appellate Tribunals']
  },
  {
    id: 'gst',
    title: 'GST Services',
    description: 'GST registration, GST filing, compliance management, and advisory.',
    icon: 'Receipt',
    features: ['GST Registration', 'Monthly/Quarterly GST Returns', 'Annual Returns Filing', 'ITC Reconciliations', 'GST Audits', 'Appellate Tribunals']
  },
  {
    id: 'financial-planning',
    title: 'Financial Planning',
    description: 'Cash flow management, budgeting, investment planning, and business finance.',
    icon: 'TrendingUp',
    features: ['Cash Flow Forecasting', 'Capital Budgeting', 'Financial Health Checks', 'Growth & Expansion Advisory']
  },
  {
    id: 'business-registration',
    title: 'Business Registration',
    description: 'Company incorporation, LLP registration, partnership registration, and compliance.',
    icon: 'Building2',
    features: ['LLC / Inc. Incorporation', 'Partnership Deeds', 'SBA Loan Documentation', 'Corporate Secretarial Services']
  },
  {
    id: 'audit-support',
    title: 'Audit Support',
    description: 'Internal audit, statutory audit assistance, risk assessment, and compliance review.',
    icon: 'ShieldCheck',
    features: ['Internal Control Reviews', 'Statutory Audit Preparation', 'Risk Assessment & Mitigation', 'Fraud Examination & Forensics']
  }
];

export const testimonialsData = [
  {
    id: 1,
    name: 'Sarah Jenkins',
    role: 'CEO, TechFlow Innovations',
    content: 'SN Associates transformed our bookkeeping and reduced our tax liabilities by 24% in the very first year. Absolute professionals!',
    rating: 5,
    avatar: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=400'
  },
  {
    id: 2,
    name: 'Marcus Vance',
    role: 'Founder, Vance Logistics',
    content: 'Their GST and compliance advisory gave us complete peace of mind. We can now focus entirely on scaling our fleet operations.',
    rating: 5,
    avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400'
  },
  {
    id: 3,
    name: 'Elena Rostova',
    role: 'Director, Artisans Guild',
    content: 'The financial planning sessions helped us weather economic shifts and optimize cash flow. Truly our most trusted business partner.',
    rating: 5,
    avatar: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=400'
  }
];

export const faqsData = [
  {
    question: 'How do I schedule a free initial consultation?',
    answer: 'You can use our interactive booking widget on this website by picking your preferred date, time, and service type. You will receive an instant confirmation.'
  },
  {
    question: 'What documents do I need for corporate tax filing?',
    answer: 'Typically, you will need your Profit & Loss statement, Balance Sheet, bank statements, previous year tax returns, and expense receipts. Our team provides a secure upload checklist.'
  },
  {
    question: 'Are your CPAs and accountants certified?',
    answer: 'Yes, our team comprises licensed Certified Public Accountants (CPAs), Chartered Accountants (CAs), and certified tax advisors with over 10 years of experience.'
  },
  {
    question: 'How does remote accounting work for startups?',
    answer: 'We securely integrate with your existing software (QuickBooks, Xero, Stripe, Bank feeds) and assign a dedicated accountant to manage your books monthly.'
  }
];
